// extracted by mini-css-extract-plugin
export default {"container":"GovernancePdfFilters_container__qGuKl","filtersClass":"GovernancePdfFilters_filtersClass__-pas7"};